import Vue from 'vue';
import Razpisi from './Razpisi.vue';

const app = new Vue({
  el: '#app',
  render: h => h(Razpisi),
});

window.app = app;



// WEBPACK FOOTER //
// ./src/razpisi.js